/* PostcodeLookup/Input.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	stop_propagation,
	text
} from "svelte/internal";

function create_fragment(ctx) {
	let div;
	let label;
	let t0;
	let label_class_value;
	let t1;
	let input;
	let input_class_value;
	let t2;
	let button;
	let t3;
	let button_class_value;
	let div_class_value;
	let dispose;

	return {
		c() {
			div = element("div");
			label = element("label");
			t0 = text("Postcode Lookup");
			t1 = space();
			input = element("input");
			t2 = space();
			button = element("button");
			t3 = text("Lookup");
			attr(label, "class", label_class_value = /*classNames*/ ctx[1].label);
			attr(label, "for", "postcode-lookup-input");
			attr(input, "id", "postcode-lookup-input");
			attr(input, "class", input_class_value = /*classNames*/ ctx[1].text);
			attr(input, "placeholder", "Enter your postcode");
			attr(input, "type", "text");
			attr(button, "class", button_class_value = /*classNames*/ ctx[1].button);
			attr(button, "type", "submit");
			attr(div, "data-testid", "container");
			attr(div, "class", div_class_value = /*classNames*/ ctx[1].container);
		},
		m(target, anchor, remount) {
			insert(target, div, anchor);
			append(div, label);
			append(label, t0);
			append(div, t1);
			append(div, input);
			set_input_value(input, /*value*/ ctx[0]);
			append(div, t2);
			append(div, button);
			append(button, t3);
			if (remount) run_all(dispose);

			dispose = [
				listen(input, "input", /*input_input_handler*/ ctx[4]),
				listen(button, "click", stop_propagation(prevent_default(/*handleClick*/ ctx[2])))
			];
		},
		p(ctx, [dirty]) {
			if (dirty & /*classNames*/ 2 && label_class_value !== (label_class_value = /*classNames*/ ctx[1].label)) {
				attr(label, "class", label_class_value);
			}

			if (dirty & /*classNames*/ 2 && input_class_value !== (input_class_value = /*classNames*/ ctx[1].text)) {
				attr(input, "class", input_class_value);
			}

			if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) {
				set_input_value(input, /*value*/ ctx[0]);
			}

			if (dirty & /*classNames*/ 2 && button_class_value !== (button_class_value = /*classNames*/ ctx[1].button)) {
				attr(button, "class", button_class_value);
			}

			if (dirty & /*classNames*/ 2 && div_class_value !== (div_class_value = /*classNames*/ ctx[1].container)) {
				attr(div, "class", div_class_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { value = "" } = $$props;
	let { classNames = {} } = $$props;
	let { onLookup = () => null } = $$props;
	const handleClick = () => onLookup(value);

	function input_input_handler() {
		value = this.value;
		$$invalidate(0, value);
	}

	$$self.$set = $$props => {
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onLookup" in $$props) $$invalidate(3, onLookup = $$props.onLookup);
	};

	return [value, classNames, handleClick, onLookup, input_input_handler];
}

class Input extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { value: 0, classNames: 1, onLookup: 3 });
	}
}

export default Input;